import Enchante151 from '../../../Media/BSD/Enchante/Enchante 15.webp'
import Enchante152 from '../../../Media/BSD/Enchante/Enchante 15.webp'





const Enchante15images =[ Enchante151,Enchante152
]

export default Enchante15images;